var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPauseButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 12
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 11
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.4 19.8h2.4v-9.6h-2.4v9.6zm4.8 0h2.4v-9.6h-2.4v9.6z"
})));
export default SvgPauseButton;